import { useState } from 'react';

import { Crop, PixelCrop } from 'react-image-crop';

/**
 * Хук для управления кадрированием изображения.
 *
 * @returns {{
 *   crop: Crop | undefined;
 *   completedCrop: PixelCrop | undefined;
 *   setCrop: (crop: Crop) => void;
 *   setCompletedCrop: (crop: PixelCrop) => void;
 *   handleImageLoad: (naturalWidth: number, naturalHeight: number) => void;
 * }} Объект, содержащий состояние и методы для управления кадрированием.
 */
export const useCrop = () => {
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleImageLoad = (..._: unknown[]) => {};

  return {
    crop,
    completedCrop,
    setCrop,
    setCompletedCrop,
    handleImageLoad,
  };
};
